var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.MODAL_ID,
        title: "Animation settings",
        size: "lg",
        "ok-title": "OK",
        "cancel-title": "Cancel",
      },
      on: { ok: _vm.handleSave, cancel: _vm.handleCancel },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _c(
                "div",
                { staticClass: "layout-animation-settings-modal__footer" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "layout-animation-settings-modal__selected-label",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.frames.length) +
                          " frame" +
                          _vm._s(_vm.frames.length === 1 ? "" : "s") +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "layout-animation-settings-modal__footer-actions",
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "light" },
                          on: {
                            click: function ($event) {
                              return cancel()
                            },
                          },
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: {
                            click: function ($event) {
                              return ok()
                            },
                          },
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "layout-animation-settings-modal" }, [
        !_vm.frames.length
          ? _c(
              "div",
              { staticClass: "layout-animation-settings-modal__empty" },
              [_vm._v("\n      No frames available\n    ")]
            )
          : _c(
              "div",
              { staticClass: "layout-animation-settings-modal__grid" },
              _vm._l(_vm.frames, function (frame, index) {
                return _c(
                  "div",
                  {
                    key: frame.id,
                    staticClass: "layout-animation-settings-modal__card",
                    class: {
                      "layout-animation-settings-modal__card--dragging":
                        _vm.draggedIndex === index,
                      "layout-animation-settings-modal__card--drop-before":
                        _vm.dragOverIndex === index &&
                        _vm.dragOverPosition === "before" &&
                        _vm.draggedIndex !== index,
                      "layout-animation-settings-modal__card--drop-after":
                        _vm.dragOverIndex === index &&
                        _vm.dragOverPosition === "after" &&
                        _vm.draggedIndex !== index,
                    },
                    attrs: { draggable: "true" },
                    on: {
                      dragstart: function ($event) {
                        return _vm.onDragStart(index, $event)
                      },
                      dragover: function ($event) {
                        return _vm.onDragOver(index, $event)
                      },
                      dragleave: function ($event) {
                        return _vm.onDragLeave(index)
                      },
                      drop: function ($event) {
                        return _vm.onDrop(index)
                      },
                      dragend: _vm.onDragEnd,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "layout-animation-settings-modal__preview",
                      },
                      [
                        frame.previewUrl
                          ? _c("img", {
                              staticClass:
                                "layout-animation-settings-modal__preview-image",
                              attrs: {
                                src: frame.previewUrl,
                                alt: `Frame ${index + 1} preview`,
                              },
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "layout-animation-settings-modal__preview-placeholder",
                              },
                              [_vm._v("\n            No preview\n          ")]
                            ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "layout-animation-settings-modal__order-badge",
                          },
                          [_vm._v(_vm._s(index + 1))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "layout-animation-settings-modal__meta" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "layout-animation-settings-modal__title",
                          },
                          [
                            _vm._v(
                              "\n            Frame " +
                                _vm._s(String(index + 1).padStart(2, "0")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "layout-animation-settings-modal__template-name",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(frame.templateName) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "layout-animation-settings-modal__info-row",
                          },
                          [
                            frame.width && frame.height
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "layout-animation-settings-modal__size",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(frame.width) +
                                        " × " +
                                        _vm._s(frame.height) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "layout-animation-settings-modal__duration-row",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "layout-animation-settings-modal__duration-icon icon-clock",
                                }),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  staticClass:
                                    "layout-animation-settings-modal__duration-input",
                                  attrs: {
                                    type: "number",
                                    size: "sm",
                                    min: _vm.MIN_DURATION,
                                    max: _vm.MAX_DURATION,
                                    step: _vm.STEP,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  model: {
                                    value: frame.durationMs,
                                    callback: function ($$v) {
                                      _vm.$set(frame, "durationMs", _vm._n($$v))
                                    },
                                    expression: "frame.durationMs",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "layout-animation-settings-modal__duration-unit",
                                  },
                                  [_vm._v("ms")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }